import { authRequest } from './utils';

/**
 * createMeetingNote :: Object -> Promise Error Object
 */
export const createMeetingNote = meetingNote =>
  authRequest({
    method: 'POST',
    url: '/meeting-notes',
    data: meetingNote,
  })
    .then(({ data }) => data);

/**
 * updateMeetingNote :: (ID, Object) -> Promise Error Object
 */
export const updateMeetingNote = (meetingNoteId, modifier) =>
  authRequest({
    method: 'PATCH',
    url: `/meeting-notes/${meetingNoteId}`,
    data: modifier,
  })
    .then(({ data }) => data);

/**
 * deleteMeetingNote :: ID -> Promise Error Object
 */
export const deleteMeetingNote = meetingNoteId =>
  authRequest({
    method: 'DELETE',
    url: `/meeting-notes/${meetingNoteId}`,
  })
    .then(({ data }) => data);

/**
 * fetchMeetingNotes :: Object -> Promise Error Object
 */
export const fetchMeetingNotes = ({
  page = 1,
  monthLimit = 2,
  withRateOnly = false,
  cancelToken,
} = {}) =>
  authRequest({
    method: 'GET',
    url: withRateOnly ? '/meeting-notes/with-rate-only' : '/meeting-notes',
    params: {
      page,
      ...(withRateOnly ? {} : { monthLimit }),
    },
    cancelToken,
  })
    .then(({ data }) => data);

/**
 * fetchMeetingNotesStatistics :: Object -> Promise Error [Object]
 */
export const fetchMeetingNotesStatistics = () => authRequest({
  method: 'GET',
  url: '/meeting-notes/meetings-statistics',
})
  .then(({ data }) => data);

/**
 * fetchTasksStatistics :: Object -> Promise Error [Object]
 */
export const fetchTasksStatistics = () => authRequest({
  method: 'GET',
  url: '/tasks/tasks-statistics',
})
  .then(({ data }) => data);

/**
 * fetchActiveRequestsStatistics :: Object -> Promise Error [Object]
 */
export const fetchActiveRequestsStatistics = () => authRequest({
  method: 'GET',
  url: '/requests/active-requests-statistics',
})
  .then(({ data }) => data);



// WEBPACK FOOTER //
// ./src/api/apiko-api/meeting-notes.js